import { render, staticRenderFns } from "./DeliveryActivityListItem.vue?vue&type=template&id=2838f128&scoped=true"
import script from "./DeliveryActivityListItem.vue?vue&type=script&lang=js"
export * from "./DeliveryActivityListItem.vue?vue&type=script&lang=js"
import style0 from "./DeliveryActivityListItem.vue?vue&type=style&index=0&id=2838f128&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2838f128",
  null
  
)

export default component.exports